export const campaignsSelector = state => ({
  workflows: state.campaigns.pendingWorkflows,
  workflowsMeta: state.campaigns.pendingWorkflowsMeta,
  sequences: state.campaigns.pendingSequences,
  sequencesMeta: state.campaigns.pendingSequencesMeta,
  reviewLoader: state.campaigns.loaders.review
});